import { formatSession } from '@shared/api/utils';
import { signIn, useSession } from 'next-auth/react';
export const useUser = () => {
    const { data: session } = useSession({
        required: true,
        onUnauthenticated: () => signIn('azure-ad'),
    });
    const formattedSession = formatSession(session);
    return formattedSession;
};
//# sourceMappingURL=useUser.js.map